export const ROUTES = {
    LOGIN: { path: "login", label: "Login" },
    LOGOUT: { path: "logout", label: "Logout" },
    RESET_PASSWORD: { path: "reset-password", label: "Reset Password" },
    OPEN_TEST: { path: "open-test", label: "Open Test" },
    DATA_INPUT: { path: "data-input", label: "Data Input" },
    INTERPRETATION: {
        path: "interpretation",
        subroutes: {
            SUMMARY_TABLE: {
                path: "summary-tables",
                label: "Summary Tables",
            },
            ANAEROBIC_THRESHOLD: {
                path: "anaerobic-threshold",
                label: "Ventilatory Anaerobic Threshold",
            },
            INBAR12: {
                path: "inbar-12",
                label: "Inbar 12 panel",
            },
            WASSWERMAN9: {
                path: "wasserman-9",
                label: "Wasserman 9 panel",
            },
        },
        label: "Interpretation",
    },
    REPORT: {
        path: "report",
        label: "Report",
    },
    LOCAL_ADMIN_DASHBOARD: {
        path: "local-admin-dashboard",
        label: "Local Admin Dashboard",
    },
};

export const TEST_PAGE_PREFIX = "/test/:testId";

export const TOKEN_EXPIRED_MSG = "Token expired.";
